import { createApiCall } from 'lib/base';

const GRANT_SUBSCRIPTION_USER = 'GRANT_SUBSCRIPTION_USER';

const grantSubscriptionUserApi = createApiCall<{
  id: string;
  userId: string;
  optionId: string;
  durationDays: number;
}>(GRANT_SUBSCRIPTION_USER, ({ id, userId, optionId, durationDays }) => ({
  endpoint: `api/admin/subscriptions/${id}/users/${userId}/options/${optionId}/grant`,
  method: 'POST',
  body: { duration_days: durationDays },
}));

export default grantSubscriptionUserApi;
